// Implements: F-UIX-019
/**
 * The platform admin's status read: `GET /admin/status` (S9c, OBS.12), one payload with the
 * database, the provider probe, the usage switches, the outbox backlog, the scheduled jobs,
 * the model health of the last hour and the global alert notice.
 *
 * A `GET`, so the client's ordinary policy applies. Anybody but the platform admin gets the
 * `404` of a path that does not exist; the route guard decides first, so no other role
 * reaches this module.
 */

import { httpRequest } from "../../../shared/api/httpClient";
import type { SystemStatusView } from "../../../types/status";

export const SYSTEM_STATUS_PATH = "/api/admin/status";

export async function fetchSystemStatus(signal?: AbortSignal): Promise<SystemStatusView> {
  const body = await httpRequest<SystemStatusView>(SYSTEM_STATUS_PATH, { signal });
  if (body === undefined) throw new Error("The system status answered no body.");
  return body;
}
